import React, {useEffect, useState} from 'react'
import {ModeleClientSource} from '../../../../../components/Models'
import {getClientSources} from '../../../../../components/requests'
import {LoadingData} from '../../../../../components/LoadingData'
import {useFormik} from 'formik'
import {Pagination} from '../../../../../components/Pagination'
import {useAuth} from '../../../../modules/auth'
import {shouldDisplayFonctionnalite} from '../../../../../components/helpers'
import {Tooltip} from 'react-tooltip'
import {Link} from 'react-router-dom'
import {Form} from 'react-bootstrap'

const ClientSourcesListPage = () => {
  const [data, setData] = useState<Array<ModeleClientSource>>([])
  const [loading, setLoading] = useState(false)
  const [clientActif, setClientActif] = useState(true)
  const [nombreDePages, setNombreDePages] = useState<number>(0)
  const [totalPages, setTotalPages] = useState<number>(0)
  const [currentPage, setCurrentPage] = useState<number>(1)
  const [searchNomClient, setSearchNomCLient] = useState<string>('')
  const [searchCodeClient, setSearchCodeCLient] = useState<string>('')
  const [searchSiren, setSearchSiren] = useState<string>('')
  const [searchSiret, setSearchSiret] = useState<string>('')
  const [isSearch, setIsSearch] = useState(false)
  const {currentUser} = useAuth()

  useEffect(() => {
    getClientsData()
  }, [currentPage, searchNomClient, searchSiren, searchSiret, clientActif, searchCodeClient])

  const getClientsData = () => {
    setLoading(true)
    getClientSources(
      !isSearch ? currentPage : 1,
      searchNomClient,
      searchSiren,
      searchSiret,
      clientActif,
      searchCodeClient
    ).then((clientsRequest) => {
      setNombreDePages(clientsRequest?.pages)
      setTotalPages(clientsRequest?.total)
      setCurrentPage(clientsRequest?.page)
      if (clientsRequest?.data !== undefined) {
        setData(clientsRequest?.data)
        setLoading(false)
        setIsSearch(false)
      }
    })
  }

  const formik = useFormik({
    initialValues: {nomClient: '', siren: '', siret: '', codeClient: ''},
    onSubmit: (values, {setSubmitting}) => {
      setSearchNomCLient(values.nomClient)
      setSearchCodeCLient(values.codeClient)
      setSearchSiren(values.siren)
      setSearchSiret(values.siret)
    },
  })

  return (
    <>
      {/* begin::Row  */}
      {shouldDisplayFonctionnalite(currentUser, 'VOIR CLIENT SOURCE') && (
        <div className='row g-5 g-xl-8'>
          {/* begin::Col  */}
          <div className='col-xxl-12'>
            <div className={`card card-xxl-stretch mb-5 mb-xl-8`}>
              {/* begin::Header */}
              <div className='card-header border-0 pt-5 d-flex justify-content-between align-items-center'>
                <h3 className='card-title fw-bold fs-3 mb-0'>Client Source</h3>
                <Form.Check type='checkbox' className='form-switch'>
                  <Form.Check.Input
                    className='me-2'
                    checked={clientActif}
                    onChange={() => setClientActif(!clientActif)}
                  />
                </Form.Check>
              </div>
              {/* debut champs recherche */}
              <form className='card-header border-0 pt-5 pb-5' onSubmit={formik.handleSubmit}>
                {/* debut recherche par siren*/}
                <div className='form-group d-flex col-lg-2'>
                  <div className='input-group'>
                    <input
                      type='text'
                      className='form-control h-100'
                      {...formik.getFieldProps('siren')}
                      name='siren'
                      placeholder='Recherche par SIREN'
                    />
                  </div>
                </div>
                {/* fin recherche par siren*/}

                {/* debut recherche par siret*/}
                <div className='form-group d-flex col-lg-2'>
                  <div className='input-group'>
                    <input
                      type='text'
                      className='form-control h-100'
                      {...formik.getFieldProps('siret')}
                      name='siret'
                      placeholder='Recherche par SIRET'
                    />
                  </div>
                </div>
                {/* fin recherche par siret*/}
                {/* debut recherche par code client*/}
                <div className='form-group d-flex col-lg-3'>
                  <div className='input-group'>
                    <input
                      type='text'
                      className='form-control h-100'
                      {...formik.getFieldProps('codeClient')}
                      name='codeClient'
                      placeholder='Recherche par code client'
                    />
                  </div>
                </div>
                {/* fin recherche par code client*/}
                {/* debut recherche par nom client */}
                <div className='form-group d-flex col-lg-3'>
                  <div className='input-group'>
                    <input
                      type='text'
                      className='form-control h-100'
                      {...formik.getFieldProps('nomClient')}
                      name='nomClient'
                      placeholder='Recherche par nom client'
                    />
                    <button
                      type='submit'
                      className='btn btn-light border-0 input-group-append h-100'
                      onClick={() => setIsSearch(true)}
                    >
                      <i className='fas fa-search text-secondary fs-1'></i>
                    </button>
                  </div>
                </div>
                {/* fin recherche par nom client */}
              </form>
              {/* fin champs recherche */}

              {/* end::Header */}
              {loading ? (
                <LoadingData />
              ) : (
                <>
                  <div className='card-body py-3'>
                    {/* begin::Table container */}
                    <div className='table-responsive'>
                      <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                        <thead>
                          <tr className='fw-bold text-muted'>
                            <th className='min-w-120px'>Source</th>
                            <th className='min-w-120px'>Code</th>
                            <th className='min-w-120px'>Nom</th>
                            <th className='min-w-100px'>Siren</th>
                            <th className='min-w-100px'>Code Postal</th>
                            <th className='min-w-100px'>Ville</th>
                            <th className='min-w-100px'>Nom entreprise</th>
                            <th className='min-w-100px'>Dénomination</th>
                            <th className='min-w-100px'>Code Naf</th>
                            <th className='min-w-100px'>Libellé code Naf</th>
                            <th className='min-w-100px'>Date création</th>
                            <th className='min-w-100px text-end'>Établissement</th>
                          </tr>
                        </thead>
                        <tbody>
                          {data.length > 0 ? (
                            data.map((source) => {
                              if (!source) return null

                              return (
                                <tr key={source.id}>
                                  <td>{source.source ?? ''}</td>
                                  <td>{source.codeClient ?? ''}</td>
                                  <td>{source.nomClientSource ?? source.nomClient ?? ''}</td>
                                  <td>{source.siren ?? ''}</td>
                                  <td>
                                    {source.codePostalSource ??
                                      source?.clientSiren?.codePostalSource ??
                                      ''}
                                  </td>
                                  <td>{source.villeSource ?? source?.ville ?? ''}</td>
                                  <td>
                                    {source.nomEntreprise ??
                                      source?.clientSiren?.nomEntreprise ??
                                      ''}
                                  </td>
                                  <td>
                                    {source.denomination ?? source?.clientSiren?.denomination ?? ''}
                                  </td>
                                  <td>{source.codeNaf ?? source?.clientSiren?.codeNaf ?? ''}</td>
                                  <td>
                                    {source.libelleCodeNaf ??
                                      source?.clientSiren?.libelleCodeNaf ??
                                      ''}
                                  </td>
                                  <td>
                                    {source.dateCreationFormate ??
                                      source?.clientSiren?.dateCreationFormate ??
                                      ''}
                                  </td>
                                  <td>
                                    <Link
                                      to={`/vente/client-sources/${
                                        source?.clientSiren?.id ?? source.id
                                      }/afficher`}
                                      className='fw-bold text-hover-primary text-muted text-decoration-none'
                                      data-tooltip-id='tooltip'
                                      data-tooltip-content='Voir établissement'
                                      data-tooltip-place='right'
                                    >
                                      {source.etablissementsClients?.length ??
                                        source?.clientSiren?.etablissementsClients?.length ??
                                        0}
                                    </Link>
                                  </td>
                                </tr>
                              )
                            })
                          ) : (
                            <tr>
                              <td colSpan={12} className='text-center'>
                                Aucun résultat trouvé
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                    {/* end::Table container */}

                    {/* begin::pagination*/}
                    <Pagination
                      totalPages={totalPages}
                      nombreDePages={nombreDePages}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                      locationState={0}
                    />
                    {/* end::pagination*/}
                    {/*Affichage du tooltip*/}
                    <Tooltip id='tooltip' />
                  </div>
                </>
              )}
            </div>
          </div>
          {/* end::Col  */}
        </div>
      )}
      {/* end::Row  */}
    </>
  )
}

export {ClientSourcesListPage}
